import { IPillProps } from './pill.models';
import { PillContainer } from './pill.style';
import { theme } from '@vfit/shared/themes';

const Pill = ({
  label = 'defaultLabel',
  pillsColor = theme.colors.text.primary,
  opacity = 0.8,
  borderColor,
}: IPillProps) => {
  return (
    <PillContainer pillsColor={pillsColor} opacity={opacity} borderColor={borderColor}>
      <span
        style={{
          color:
            pillsColor === theme.colors.text.primary
              ? theme.colors.text.inverse
              : theme.colors.text.primary,
        }}
      >
        {label}
      </span>
    </PillContainer>
  );
};

export default Pill;

